import React, { useState } from 'react';
import { postData } from '../Services/api';
import { toast } from 'react-toastify';

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [loading, setLoading] = useState(false);
    const [visibility, setVisibility] = useState({
        current: false,
        new: false,
        confirm: false
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const toggleVisibility = (field) => {
        setVisibility({ ...visibility, [field]: !visibility[field] });
    };
    const validateChangePassword = () => {
        const { currentPassword, newPassword, confirmPassword } = formData;

        if (!currentPassword.trim()) {
            toast.dismiss();
            toast.error("Old password is required.");
            return false;
        }

        if (!newPassword.trim()) {
            toast.dismiss();
            toast.error("New password is required.");
            return false;
        }

        if (newPassword.length < 6) {
            toast.dismiss();
            toast.error("New password must be at least 6 characters.");
            return false;
        }

        if (newPassword === currentPassword) {
            toast.dismiss();
            toast.error("New password must be different from the old password.");
            return false;
        }

        if (newPassword !== confirmPassword) {
            toast.dismiss();
            toast.error("Confirm password does not match.");
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateChangePassword()) return;

        setLoading(true);
        try {
            const res = await postData('/auth/change-password', formData);
            if (res.status) {
                toast.dismiss();
                toast.success(res.message || "Password changed successfully.");
                setFormData({ currentPassword: "", newPassword: "", confirmPassword: "" });
            } else {
                toast.dismiss();
                toast.error(res.message || "Something went wrong.");
            }
        } catch (error) {
            console.log("error change password", error);
            toast.dismiss();
            toast.error(error?.response?.data?.message || "Server error.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card-body">
            <form onSubmit={handleSubmit}>
                <div className="row justify-content-center">
                    <div className="col-sm-4">
                        <div className='mb-3'>
                            <label className="form-label">Old Password</label>
                            <div className="input-group">
                                <input
                                    type={visibility.current ? "password" : "text"}
                                    name="currentPassword"
                                    value={formData.currentPassword}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                                <span className="input-group-text" onClick={() => toggleVisibility('current')}
                                    style={{ cursor: 'pointer' }} id="validationTooltipUsernamePrepend">
                                    <i className={`fa ${visibility.current ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </span>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <label className="form-label">New Password</label>
                            <div className="input-group">
                                <input
                                    type={visibility.new ? "password" : "text"}
                                    name="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                                <span className="input-group-text" onClick={() => toggleVisibility('new')}
                                    style={{ cursor: 'pointer' }} id="validationTooltipUsernamePrepend">
                                    <i className={`fa ${visibility.new ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </span>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <label className="form-label">Confirm Password</label>
                            <div className="input-group">
                                <input
                                    type={visibility.confirm ? "password" : "text"}
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                                <span className="input-group-text" onClick={() => toggleVisibility('confirm')}
                                    style={{ cursor: 'pointer' }} id="validationTooltipUsernamePrepend">
                                    <i className={`fa ${visibility.confirm ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-end btn-page mt-3">
                    <div className="btn btn-outline-secondary me-2">Cancel</div>
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                        {loading ? 'Saving...' : 'Change Password'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ChangePassword;
